import { useSelector } from 'react-redux'
import { Alert, Layout } from 'antd'
import { selectFlags } from '@Builder/QuoteDetailPage/selectors'
import {
    SALES_ORDER_DETAILS,
    ORDER_CANCELLATION_REFUND_URL,
} from '@Orders/constants'

import Box from '~/core/Box'
import Link from '~/core/Link'
import Text from '~/core/Text'
import { isJapan } from '~/lib/appRegionConstants'
import { mailtoLink } from '~/lib/mailtoLink'
import { SALES_EMAIL } from '~/lib/emailAndUrls'
import styles from '../styles.css'

interface SyntheticEvent {
    preventDefault(): void
}

interface OrderSummaryFooterPropsType {
    openChat: () => void
}

export const OrderSummaryFooter = (props: OrderSummaryFooterPropsType) => {
    const { openChat } = props

    const { disableDriftMessaging } = useSelector(selectFlags)

    const contactSalesLink = mailtoLink(SALES_EMAIL, 'Question about my order?')
    const timezone = isJapan() ? 'JST' : 'PST'

    return (
        <Layout.Footer>
            <Alert
                className={styles.infoAlert}
                message={
                    <Text fontWeight={300}>
                        Have questions about your order?{' '}
                        {disableDriftMessaging ? (
                            <Link
                                data-test-target="email-us"
                                href={contactSalesLink}
                                name="contact-sales"
                                placement={SALES_ORDER_DETAILS}
                                target="_blank"
                            >
                                Contact Sales
                            </Link>
                        ) : (
                            <Link
                                name="chat-with-us"
                                data-test-target="chat-with-us"
                                onClick={(evt: SyntheticEvent) => {
                                    evt.preventDefault()
                                    openChat()
                                }}
                                placement={SALES_ORDER_DETAILS}
                            >
                                Please chat with us.
                            </Link>
                        )}
                    </Text>
                }
                type="info"
                showIcon
            />
            <Box className={styles.textWrapper}>
                <Text>
                    In most cases, orders cannot be changed or cancelled past
                    the cutoff time on the day the order is placed (typically
                    3PM {timezone}).
                </Text>
                <p>
                    Please review our{' '}
                    <Link
                        data-test-target="order-cancellation-refund"
                        href={ORDER_CANCELLATION_REFUND_URL}
                        name="order-cancellation-refund"
                        placement={SALES_ORDER_DETAILS}
                        target="_blank"
                    >
                        Order Cancellation and Refund Policy
                    </Link>{' '}
                    for more information.
                </p>
            </Box>
        </Layout.Footer>
    )
}

export default OrderSummaryFooter
